import { render, staticRenderFns } from "./PosturaChildsAlive.vue?vue&type=template&id=09c86322"
import script from "./PosturaChildsAlive.vue?vue&type=script&lang=js"
export * from "./PosturaChildsAlive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports